import { all, fork } from 'redux-saga/effects';

import api from 'sagas/api';
import app from 'sagas/app';
import thirdpartyAuth from 'sagas/thirdpartyAuth';
import epg from 'sagas/epg';

export default function* root() {
  yield all([
    fork(api),
    fork(app),
    fork(epg),
    fork(thirdpartyAuth),
  ]);
}
